@if (activeStatus) {
  <div>{{ activeStatus.key }}</div>
} @else {
  -
}
